module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-16"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v("Faces")]), _vm._v(" "), _c('p', {
    staticClass: "Top-quote"
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("‘He who prays must turn his eyes down and his heart up’.")])]), _vm._v(" "), _c('p', {
    staticClass: "Top-quote-source"
  }, [_vm._v("Rabbinic saying")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Faces signal ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("where we’re at")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("who we are:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Level, face to face,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("abled and ablaze?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Upturned, catching vision")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of some greater love?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Or, downward,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("buried in our hands,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("heart-constricting grief")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("darkness of a blinded")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("sight?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3679d014","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-18.vue
// module id = 111
// module chunks = 0